import Confirm from "./Confirm";

export default Confirm.create({});



// WEBPACK FOOTER //
// ./src/components/common/confirmService/index.js